var EditImageModal = {
	imageSelectLabel: "Image size",
	imageUrlLabel: "Image URL",
	alignmentLabel: "Alignment",
	wrapTextLabel: "Wrap text around image",
	spacing: {
		title: "Spacing",
		top: "Top",
		left: "Left",
		right: "Right",
		bottom: "Bottom"
	},
	removeImage: "Remove image"
};
var _en = {
	EditImageModal: EditImageModal
};

export { EditImageModal, _en as default };
